module.exports = __webpack_public_path__ + "img/BlinkArt_Sword7_Red.6c60cb1c.png";